import React, { Component } from 'react';
import { Alert, Box,Button,IconButton, Menu, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { MoreVertRounded, QrCode2Rounded, TroubleshootRounded } from '@mui/icons-material';
import { isEmpty } from 'lodash';
import { green, red } from '@mui/material/colors';
import Sessions from '../Forms/Sessions';
import Currency from '../../../common/Currency';
import Dialog from '../../../common/Dialog';
// import SessionPics from '../Forms/SessionPics';


class SessionList extends Component {
    state = { 
        type: "",
        selected: {},
        openFilters: false,
        openUpdate: false,
        openUpdatePics: false,
        anchorEl: null, 
        openMenu: "", 
        deleteSession: false, 
        toDelete: {},
        op: ""
    }

    handleOpenUpdate = (data, form = "openUpdate", open = true) => {
        this.setState({
			selected: data ,
            [form]: open,
            op: "",
            openMenu: "",
            anchorEl: null
		})
    }
    updateStatus = (session, op) => {
        this.setState({
			openUpdateStatus: true,
            selected: session,
            op,
		})
    }
    handleSubmit = async () => {
        
        await this.props.updateSessionStatus(this.state.selected.session_id, this.state.op)
        
        // // if NoErrors ...
        if(this.props.STATE.sessions.error){
            this.props.notif("error",`Un problème est survenu: ${this.props.STATE.sessions.error}`)
        } else { 
            this.props.notif("success", "la session a été modifiée")
            this.handleOpenUpdate({}, "openUpdateStatus", false)
        }
    }
    render() {
        const { selected, openUpdate, openUpdatePics, anchorEl, openMenu, openUpdateStatus, op } = this.state;
        const { SESSIONS } = this.props
        return (
            <Box>
                
                {openUpdate && !isEmpty(selected) &&
                    <Sessions
                        update
                        session={this.state.selected}
                        {...this.props}
                        handleClose={() => this.handleOpenUpdate({}, "openUpdateStatus", false)}
                    />
                }
                {openUpdateStatus && !isEmpty(selected) && op == "publish" &&
                    <Dialog 
                        title={`Publier la liste "${selected.session_name}"`}
                        close={() => this.handleOpenUpdate({}, "openUpdateStatus", false)}
                        submitAction={this.handleSubmit}
                    >
                        <Alert severity="info">
                            La liste deviendra visible chez tous les employés
                        </Alert>
                    </Dialog>
                }
                {openUpdateStatus && !isEmpty(selected) && op == "over" &&
                    <Dialog 
                        title={`Mettre fin à la session "${selected.session_name}"`}
                        close={() => this.handleOpenUpdate({}, "openUpdateStatus", false)}
                        submitAction={this.handleSubmit}
                    >
                        <Alert severity="warning">
                            La liste ne sera plus visible pour les employés
                        </Alert>
                    </Dialog>
                }
                
                <Box p={1}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Intitulé</TableCell>
                                <TableCell>Date Début</TableCell>
                                <TableCell>Date de Fin</TableCell>
                                <TableCell>Statut</TableCell>
                                <TableCell>Options</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!isEmpty(SESSIONS)  && Object.values(SESSIONS).map(session =>                                
                                <TableRow >
                                    <TableCell className="a-like" onClick={() => this.props.handleSingle(session)}>{session.session_name}</TableCell> 
                                    <TableCell>{session.session_validate && new Date(session.session_publication_date).toLocaleDateString("fr-FR")}</TableCell>
                                    <TableCell>{session.session_is_over && new Date(session.session_end_date).toLocaleDateString("fr-FR")}</TableCell>
                                    <TableCell>
                                        {!session.session_validate ? 
                                            <Button variant="contained" color="secondary" onClick={() => this.updateStatus(session, "publish")}>
                                                Publier
                                            </Button>
                                        : 
                                            <>
                                                {!session.session_is_over ?
                                                    <Button  color="primary" onClick={() => this.updateStatus(session, "over")}>
                                                        Fin
                                                    </Button>
                                                :
                                                    "Session Terminée"
                                                }
                                            </>
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <>
                                            <IconButton 
                                                aria-controls={`option-menu${session.session_id}`} 
                                                aria-haspopup="true"
                                                onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : session.session_id}) }>
                                                <MoreVertRounded />
                                            </IconButton>

                                            <Menu
                                                MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                                }}
                                                id={`option-menu${session.session_id}`}
                                                anchorEl={anchorEl}                                               
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                open={ openMenu === session.session_id}
                                                onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                                            >
                                                <MenuItem onClick={() => this.handleOpenUpdate(session) } >Modifier</MenuItem>                
                                                {/* <MenuItem onClick={() => this.handleOpenUpdate(session, "openUpdatePics") } >Modifier Photos</MenuItem>                 */}
                                                {/* <MenuItem 
                                                    onClick={() => this.setState({ 
                                                        deleteSession: true, 
                                                        toDelete: session, 
                                                        openMenu: "", 
                                                        anchorEl:null
                                                    }) }
                                                >
                                                    Supprimer
                                                </MenuItem> */}
                                            </Menu>
                                        </>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </Box>
            </Box>
                
        );
    }
}

export default SessionList;



// "admin_account_id": "eee68d3f-b2e9-4f4a-b1c8-51a34ceb2f08",
// "session_articles": "acdd20c4-16b8-4cb1-aa69-83f4f98f3179, 78423cbc-828c-4d86-b035-dda0d8c6fe60, 6261acb0-4ccb-4cbe-94f2-09617bd12d33",
// "session_creation_date": "2023-01-03T19:31:24.785823+01:00",
// "session_creator": "81c64ed7-0797-4b08-8acc-9d3b82e9e1e2",
// "session_desc": "test 1",
// "session_end_date": "0001-01-01T00:00:00Z",
// "session_id": "4c62fe7b-34e2-444d-86c6-f831e0cf7b9b",
// "session_is_over": false,
// "session_name": "Printemps 2023",
// "session_publication_date": "0001-01-01T00:00:00Z",
// "session_update_date": "2023-01-05T10:36:24.306015+01:00",
// "session_validate": false